// Plate helpers — mirror backend routes/clients._validate_plate.
const SIV_RE = /^[A-Z]{2}\d{3}[A-Z]{2}$/;
const FNI_RE = /^(\d{1,4})([A-Z]{1,3})(\d{2}|2[AB]|97\d)$/;

export const formatPlateInput = (raw, foreign = false) => {
  const up = (raw || "").toUpperCase();
  if (foreign) return up.replace(/[^A-Z0-9 -]/g, "").slice(0, 15);
  const c = up.replace(/[^A-Z0-9]/g, "");
  if (/^[A-Z]/.test(c)) {
    const s = c.slice(0, 7);
    return [s.slice(0, 2), s.slice(2, 5), s.slice(5, 7)].filter(Boolean).join("-");
  }
  const m = c.match(/^(\d{0,4})([A-Z]{0,3})(.{0,3})/);
  return [m[1], m[2], m[3]].filter(Boolean).join(" ");
};

export const plateError = (raw, foreign = false) => {
  const s = (raw || "").trim();
  if (!s) return "";
  if (foreign) return s.length < 2 ? "Plaque trop courte" : "";
  const c = s.replace(/[^A-Z0-9]/g, "");
  if (SIV_RE.test(c) || FNI_RE.test(c)) return "";
  return "Format attendu : AB-123-CD (ou ancien format 1234 AB 63)";
};
